import React from "react";
import { capitalizeEachWord } from "../../../utils/commonFunctions";

const MetaDataTab = ({ candidateDetails, activeDocData, docVerification, DOB }) => {
  const key = activeDocData?.docData?.filename?.split(".")[0]?.toLowerCase();
  const FULL_NAME =
    `${candidateDetails?.first_name} ${candidateDetails?.last_name}` || "N/A";
  const MOBILE_NUMBER = `${candidateDetails?.contact_no}` || "N/A";
  let label_First = "Full Name";
  let label_Second = "Mobile Number";
  let label_Third = "D.O.B";
  let value_First = capitalizeEachWord(FULL_NAME);
  let value_Second = MOBILE_NUMBER;
  let value_Third = DOB;

  let verification_message = "";
  let verification_code = null;

  if (key === "aadharcardimage") {
    const AADHAR_NUMBER = `${candidateDetails?.aadhar_no}` || "N/A";
    label_Second = "Aadhar Number";
    value_Second = AADHAR_NUMBER;
    const data =
      docVerification?.find((e) => e.documentType === "Aadhar_Card") || null;
    if (data) {
      verification_code = data?.aadharVerificationDetails?.status_code;
      verification_message =
        data?.aadharVerificationDetails?.message || data?.aadharVerificationDetails?.message_code || "";
    }
  } else if (key === "pancardimage") {
    const PAN_NUMBER = `${candidateDetails?.pan_no}` || "N/A";
    label_Second = "PAN Number";
    value_Second = PAN_NUMBER?.toUpperCase();
    const data =
      docVerification?.find((e) => e.documentType === "Pan_Card") || null;
    if (data) {
      verification_code = data?.aadharVerificationDetails?.status_code;
      verification_message =
        data?.aadharVerificationDetails?.message || data?.aadharVerificationDetails?.message_code || "";
    }
  } else if (key === "upload cancelled cheque") {
    const BANK_NAME = `${candidateDetails?.bank_name}` || "N/A";
    const IFSC = `${candidateDetails?.ifsc_code}` || "N/A";
    const ACC_NO = `${candidateDetails?.bank_acc_no}` || "N/A";
    label_First = "Bank Name";
    label_Second = "Account Number";
    label_Third = "IFSC Code";
    value_First = BANK_NAME;
    value_Second = ACC_NO;
    value_Third = IFSC?.toUpperCase();
    const data =
      docVerification?.find((e) => e.documentType === "Bank_Verification") ||
      null;
    if (data) {
      verification_code = data?.aadharVerificationDetails?.status_code;
      verification_message =
        data?.aadharVerificationDetails?.message || data?.aadharVerificationDetails?.message_code || "";
    }
  } else if (key === "upload blood group") {
    const BLOOD_GROUP = `${candidateDetails?.blood_group}` || "N/A";
    label_Second = "Blood Group";
    value_Second = BLOOD_GROUP;
  }

  return (
    <>
      <div
        className="text-sm mb-2 px-3 py-2 flex justify-content-between"
        style={{
          justifyContent: "space-between",
          border: "1px solid #C9C9C9",
        }}
      >
        <span
          style={{
            flex: "1 1",
            borderRight: "1px solid black",
            textAlign: "center",
          }}
        >
          <span className="font-medium">{label_First}:</span> {value_First}
        </span>

        <span
          style={{
            flex: "1 1",
            borderRight: "1px solid black",
            textAlign: "center",
          }}
        >
          <span className="font-medium">{label_Second}:</span> {value_Second}
        </span>
        <span style={{ flex: "1 1", textAlign: "center" }}>
          <span className="font-medium">{label_Third}:</span> {value_Third}
        </span>
      </div>
      {(key === "aadharcardimage" ||
        key === "pancardimage" ||
        key === "upload cancelled cheque") &&
      docVerification &&
      verification_code ? (
        <div
          className="mb-2"
          style={{
            height: "33px",
            background: `${
              verification_code === 200 ? "rgb(0 172 26 / 5%)" : "rgb(255, 248, 248)"
            }`,
            fontWeight: "bold",
            border: `1px solid ${
              verification_code === 200 ? "#00AC1A" : "rgb(255, 195, 195)"
            }`,
            padding: "5px 10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              gap: "0.5rem",
              display: "flex",
              alignItems: "center",
              color: `${verification_code === 200 ? "#00AC1A" : "red"}`,
            }}
          >
            <span style={{ fontWeight: "bold" }}>Verification Status :</span>
            <span>
              {" "}
              {verification_code === 200 ? "Successful" : "Unsuccessful"}{" "}
              {verification_code !== 200 ? `(${verification_message})` : ``}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default MetaDataTab;
